<div class="registration-layout">
  <router-outlet></router-outlet>
</div>
